var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#FFF",
    d: "M24.611 23.224 13.525 12.139 24.611 1.52l-.955-.55-11.087 10.213L1.521.97l-.994.93 11.087 10.239L.527 23.224l.956.957L12.569 13.94l11.087 10.241.955-.957z"
  })));
};

export { SvgCross as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNSIgaGVpZ2h0PSIyNSI+CiAgICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGZpbGw9IiNGRkYiIGQ9Ik0yNC42MTEgMjMuMjI0IDEzLjUyNSAxMi4xMzkgMjQuNjExIDEuNTJsLS45NTUtLjU1LTExLjA4NyAxMC4yMTNMMS41MjEuOTdsLS45OTQuOTMgMTEuMDg3IDEwLjIzOUwuNTI3IDIzLjIyNGwuOTU2Ljk1N0wxMi41NjkgMTMuOTRsMTEuMDg3IDEwLjI0MS45NTUtLjk1N3oiLz4KPC9zdmc+Cg==";